import {useRoutes} from 'react-router-dom';

import UnauthorizedRoutes from './UnauthorizedRoutes';
import AdminAuthorizedRoutes from "./AdminAuthorizedRoutes";
import {useSelector} from "react-redux";
import {getState} from "../../redux/actions/actions";
import OwnerAuthorizedRoutes from './OwnerAutherizedRoutes';
import UserAuthorizedRoutes from './UserAutherizedRoutes';
import TicketTrackerAuthorizedRoutes from './TicketTrackerAutherizedRoutes';
import SuperAdminAuthorizedRoutes from './SuperAdminAutherizedRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const authState = useSelector((state: any) => state.auth.authData);
    const user = getState(authState);

    const ROLES_ROUTES: any = {
        0: OwnerAuthorizedRoutes(user),
        1: UserAuthorizedRoutes(user),
        2: AdminAuthorizedRoutes(user),
        3: TicketTrackerAuthorizedRoutes(user),
        4: SuperAdminAuthorizedRoutes(user),
        undefined: UnauthorizedRoutes
    };

    return useRoutes(user ? ROLES_ROUTES[Number(user?.role)] || UnauthorizedRoutes : UnauthorizedRoutes);
}
